import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";

export default class extends ApplicationController {

  static targets = ["hm0_output"];
  connect() {
    super.connect();
    // console.log("Piste controller js en cours ..")
    var self = this;

   window.initIntTelSimple = this.initIntTel;
       if (
      $("#partial-appel-content").length &&
      $("#partial-appel-content").text().trim() == "Chargement en cours ..."
    ) {
      //on est sur le show
      setTimeout(() => this.piste_hm_ajax_appel(), 300);
    }
    //emailing
    if (
      $("#partial-marketing-contact-content").length &&
      $("#partial-marketing-contact-content").text().trim() ==
      "Chargement en cours ..."
    ) {
      //on est sur le show
      setTimeout(() => this.piste_hm_ajax_marketing_contact(), 300);
    }

    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list

      //on est sur la vue list
      if ($("#activate_em").length) {
        this.show_edition_multiple();
      }
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
      $("#filterrific_with_chiffre_daffaires_inf").on("input", function () {
        $("#target_chiffre_daffaires_inf").val(
          $("#filterrific_with_chiffre_daffaires_inf").val()
        );
      });
      $("#filterrific_with_chiffre_daffaires_sup").on("input", function () {
        $("#target_chiffre_daffaires_sup").val(
          $("#filterrific_with_chiffre_daffaires_sup").val()
        );
      });
      $("#target_chiffre_daffaires_inf").on("input", function () {
        $("#filterrific_with_chiffre_daffaires_inf").val(
          $("#target_chiffre_daffaires_inf").val()
        );
      });
      $("#target_chiffre_daffaires_sup").on("input", function () {
        $("#filterrific_with_chiffre_daffaires_sup").val(
          $("#target_chiffre_daffaires_sup").val()
        );
      });

      ////

      $('#mySidebar #table_custom_ .switch input').each(function () {
        let me = $(this)
        if ((me.attr('type') === 'checkbox') && (me.attr('class').includes('preference_columns'))) {
          me[0].addEventListener("change", (e) => {
            let hiddenHtmlClass = e.target.id.replace('filterrific_', '')
            // console.log(hiddenHtmlClass)
            if (e.target.checked) {
              // console.log("show ", e.target)
              $('.' + hiddenHtmlClass).show()
            } else {
              // console.log("hide ", e.target)
              $('.' + hiddenHtmlClass).hide()
            }
          })
        }
      })
      /////

      var targetElement = document.getElementById("mySidebar");
      targetElement.addEventListener("scroll", (event) => {
        var element = document.getElementById("mySidebar");
        document.getElementById("scrollevel").value = element.scrollTop;
      });
    }
  }

  iniFla() {
    let fields = document.querySelectorAll(".flatpickr");

    for (let j = 0; j < fields.length; j++) {
      fields[j].classList.add("fx-input-date-sidbar-menu");
    }
  }

  show_edition_multiple() {
    if (this.current_app && this.params) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/pistes/show_ajax_edition_multiple?" +
        this.params +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#edition_multiple").html("");
          $("#edition_multiple").html(text);
          MicroModal.init();
        })
      );
    }
  }

  initZindex() {
    let index = [
      ...document.querySelectorAll("#mySidebar DIV"),
      ...document.querySelectorAll("#mySidebar INPUT"),
      ...document.querySelectorAll("#mySidebar I"),
      ...document.querySelectorAll("#mySidebar SPAN"),
      ...document.querySelectorAll("#mySidebar A")
    ];

    for (let j = 0; j < index.length; j++) {
      index[j].style.zIndex = 100;
    }
  }

  rerender() {
    var row = $("#search");
    var row2 = $("#quick_sort");
    row.insertAfter(row2);
  }
  //appels
  piste_hm_ajax_appel() {
    if (this.current_app && this.piste_id) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/pistes/show_ajax_for_hm_appels?piste_id=" +
        this.piste_id +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-appel-content").html("");
          $("#partial-appel-content").html(text);
        })
      );
    }
  }
  //emailing
  piste_hm_ajax_marketing_contact() {
    if (this.current_app && this.piste_id) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/pistes/show_ajax_for_hm_marketing_contacts?piste_id=" +
        this.piste_id +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-marketing-contact-content").html("");
          $("#partial-marketing-contact-content").html(text);
        })
      );
    }
  }

 
  get params() {
    return this.data.get("params");
  }

  get current_app() {
    return this.data.get("app");
  }
  get piste_id() {
    return this.data.get("pisteid");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}
